// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ArchivePeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/archive_period/{id}
 *
 * Returns success flag after archiving a paid period.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ArchivePeriodResponseDados = boolean;

export type Payroll_ArchivePeriodResponse = ApiResponse<Payroll_ArchivePeriodResponseDados>;

registerResponseContract('Payroll_ArchivePeriodResponse', {})
